export const TROUBLE_SHOOTING_HEADER = "Trouble Getting your SMS Code?";

export const TROUBLE_SHOOTING_SUBHEADER =
  "For security purposes, the account associated with **phone_number** has been locked out for 10 minutes.";
